export enum AppsAccessScopes {
  CAN_LOG_IN_STUDENT_APP = 'can_log_in_student_app',
  CAN_LOG_IN_TEACHER_APP = 'can_log_in_student_app',
}
